import React from "react";
import { useAppContext } from "../../contexts/AppContext";

function NavCard({ image, text }) {
  const { translate, backendUrl } = useAppContext();
  return (
    <div className="d-flex w-100">
      <div className="p-2">
        {image ? (
          <img
            src={`${backendUrl}/${image}`}
            loading="lazy"
            alt="nav photos"
            style={{ width: "100px" }}
          ></img>
        ) : (
          <div>
            {" "}
            <p className="bi bi-light" style={{ fontSize: "40px" }}></p>
          </div>
        )}
      </div>
      <div className="d-flex text-start p-2">
        <p>{text && translate(text)}</p>
      </div>
    </div>
  );
}

export default NavCard;
